import React from 'react';
import { Link } from 'react-router';
import { Card } from '../../../components/Card';
import { Section } from '../../../components/Section';
import { Button } from '../../../components/Button';
import useTheme from '../../../hooks/useTheme';
import { megaGreenData } from '../../../data/data';
import { getPillStyle } from '../../../utils/styleVariables';

interface FeaturedProjectsProps {
    index?: number;
}

export const FeaturedProjects: React.FC<FeaturedProjectsProps> = ({ index }) => {
    const { theme, breakpoint } = useTheme();
    const featuredProjectIds = megaGreenData.home.featuredProjects;
    const allProjects = megaGreenData.projects.projects;
    const featuredProjects = featuredProjectIds
        .map(id => allProjects.find(p => p.id === id))
        .filter((project): project is NonNullable<typeof project> => project !== undefined);

    const getGridColumns = () => {
        if (breakpoint.xs || breakpoint.sm) return '1fr';
        if (breakpoint.md) return 'repeat(2, 1fr)';
        return 'repeat(3, 1fr)';
    };

    return (
        <Section index={index}>
            <h2
                style={{
                    fontSize: breakpoint.xs || breakpoint.sm ? '28px' : '34px',
                    fontWeight: 700,
                    color: theme.text.primary,
                    marginBottom: '48px',
                }}
            >
                Featured projects
            </h2>

            <div
                style={{
                    display: 'grid',
                    gridTemplateColumns: getGridColumns(),
                    gap: '24px',
                    marginBottom: '32px',
                }}
            >
                {featuredProjects.map((project) => (
                    <Card key={project.id} hoverable style={{ display: 'flex', flexDirection: 'column' }}>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'flex-start',
                                marginBottom: '12px',
                                gap: '8px',
                            }}
                        >
                            <div
                                style={{
                                    fontSize: '12px',
                                    fontWeight: 600,
                                    padding: '4px 10px',
                                    borderRadius: '12px',
                                    border: '1px solid',
                                    ...getPillStyle(theme, project.primaryServiceLine),
                                }}
                            >
                                {project.id}
                            </div>
                            <div
                                style={{
                                    fontSize: '12px',
                                    fontWeight: 500,
                                    padding: '4px 10px',
                                    borderRadius: '12px',
                                    border: '1px solid',
                                    ...getPillStyle(theme, project.sector),
                                }}
                            >
                                {project.projectType}
                            </div>
                        </div>
                        <h3
                            style={{
                                fontSize: '18px',
                                fontWeight: 600,
                                color: theme.text.primary,
                                marginBottom: '8px',
                            }}
                        >
                            {project.client}
                        </h3>
                        <div
                            style={{
                                fontSize: '14px',
                                color: theme.text.muted,
                                marginBottom: '8px',
                            }}
                        >
                            <div>Sector: {project.sector}</div>
                            <div>Location: {project.location}</div>
                            <div>Service: {project.primaryServiceLine}</div>
                        </div>
                        <Link to={`/projects/${project.id}`}
                            style={{ textDecoration: 'none', marginTop: 'auto' }}
                        >
                            <Button variant="secondary" style={{ width: '100%', marginTop: '12px' }}>
                                View case study
                            </Button>
                        </Link>
                    </Card>
                ))}
            </div>
        </Section>
    );
};

